/**
 *
 * SignupPage
 *
 */

import React, { Fragment } from 'react';
import { Dispatch, compose } from 'redux';
import { checkEmailSubmit, resetState as resetStateActions, setLoading, signupSubmit } from './actions';

import SignupForm, { CustomerInfo } from 'components/SignupForm/SignupForm';
import { push } from 'connected-react-router';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { RouteProps } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import translations from 'translations';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import SignupInstruction from './components/SignupInstruction';
import SignupSuccess from './components/SignupSuccess';
import messages from './messages';
import reducer from './reducer';
import saga from './saga';
import selectSignupPage from './selectors';
import { RootState } from './types';

interface OwnProps extends RouteProps {
  signuppage: any;
  location: {
    pathname: string;
    hash: string;
    state: {
      success: boolean;
    };
    search: string;
  };
}

interface StateProps {}

interface DispatchProps {
  onSubmitSignup: (data: any) => void;
  onCheckEmail: (data: any) => void;
  goToSignIn: () => void;
  resetState: () => void;
  setLoading: (data: boolean) => void;
}

interface ISignupPageValidateParams {
  createdBy: string | null;
}

type Props = StateProps & DispatchProps & OwnProps;

export class SignupPage extends React.PureComponent<Props> {
  public componentWillUnmount() {
    this.props.resetState();
  }

  public componentDidMount() {
    if (this.props.location.state?.success) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }

  validateParams = (params: ISignupPageValidateParams): boolean => {
    return Boolean(params.createdBy);
  };

  public render() {
    const {
      signuppage: { isCheckingEmail, validationEmailMessage, listSalesPIC, loading },
      location,
      setLoading,
    } = this.props;
    const query = location && (new URLSearchParams(location.search) as any);

    const params: ISignupPageValidateParams = {
      createdBy: query.get('createdBy'),
    };

    if (!this.validateParams(params)) {
      return location.state?.success ? <SignupSuccess /> : <SignupInstruction />;
    }

    const customerInfo: CustomerInfo = {
      userName: query.get('userName'),
      email: query.get('email'),
      companyName: query.get('companyName'),
      phoneNumber: query.get('phoneNumber'),
      provinceId: query.get('provinceId'),
      districtId: query.get('districtId'),
      wardId: query.get('wardId'),
      roleAtBusiness: query.get('roleAtBusiness'),
      addressNo: query.get('addressNo'),
      acquisitionSource: query.get('acquisitionSource'),
      buyerCustomerContactRequestId: query.get('buyerCustomerContactRequestId'),
      createdBy: query.get('createdBy'),
      businessType: query.get('businessType'),
      businessCategory: query.get('businessCategory'),
      businessTeam: query.get('businessTeam'),
      salePicName: query.get('salePicName'),
      odooCustomerId: query.get('odooCustomerId'),
      crmAcqType: query.get('crmAcqType'),
      crmSourceType: query.get('crmSourceType'),
      linkHubSpot: query.get('linkHubSpot'),
      branchNumber: query.get('branchNumber'),
      buyerPriority: query.get('buyerPriority'),
      buyerType: query.get('buyerType'),
    };

    return (
      <Fragment>
        <Helmet>
          <title>{`${translations(messages.header)} | Nhà Cung Cấp Kamereo`}</title>
          <meta name="description" content={`${translations(messages.header)}`} />
        </Helmet>
        <SignupForm
          onSubmit={this.props.onSubmitSignup}
          onCheckEmail={this.props.onCheckEmail}
          isCheckingEmail={isCheckingEmail}
          validationEmailMessage={validationEmailMessage}
          customerInfo={customerInfo}
          listSalesPIC={listSalesPIC}
          loading={loading}
          setLoading={setLoading}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
  signuppage: selectSignupPage(),
});

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
  return {
    onSubmitSignup: (data: any) => dispatch(signupSubmit(data)),
    onCheckEmail: (data: any) => dispatch(checkEmailSubmit(data)),
    goToSignIn: () => dispatch(push('/signIn')),
    resetState: () => dispatch(resetStateActions()),
    setLoading: (data: boolean) => dispatch(setLoading(data)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

// <OwnProps> restricts access to the HOC's other props. This component must not do anything with reducer hoc
const withReducer = injectReducer<OwnProps>({
  key: 'signupPage',
  reducer: reducer,
});
// <OwnProps> restricts access to the HOC's other props. This component must not do anything with saga hoc
const withSaga = injectSaga<OwnProps>({ key: 'signupPage', saga: saga });

export default compose(withReducer, withSaga, withConnect)(SignupPage);
